"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_input_mask_1 = __importDefault(require("react-input-mask"));
const prop_types_1 = __importDefault(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
/**
 * @param {any} [props] Props for this component.
 * @return {JSX.Element} JSX Element
 * @type {React.FunctionComponent<any>}
 */
const InputMask = (_a) => {
    var { ariaLabel = "Please insert a number", className, placeholder, size, children, disabled } = _a, props = __rest(_a, ["ariaLabel", "className", "placeholder", "size", "children", "disabled"]);
    // When not passing a render function as children, will use a default <input> element
    const isUsingDefaultInputElement = children === undefined;
    const classes = (0, classnames_1.default)("gerudo-input", "gerudo-input-mask", className, {
        lg: size === "large",
        sm: size === "small",
        // We only want to apply the antd input styles when using the default <input> element.
        // Otherwise the custom children will define its own style.
        "ant-input ant-input-lg": isUsingDefaultInputElement,
    });
    // For some reason the disabled prop is not passed down to the children render function
    // props so we have to pass it manually
    const wrappedChildren = typeof children === "function" ? (args) => children(Object.assign(Object.assign({}, args), { disabled })) : children;
    return (react_1.default.createElement(react_input_mask_1.default, Object.assign({ className: classes, size: size, placeholder: placeholder, "aria-label": ariaLabel, disabled: disabled }, props), wrappedChildren));
};
InputMask.displayName = "InputMaskValidator";
InputMask.defaultProps = {
    onClick: () => { },
    className: "",
    placeholder: "",
    size: "large",
    onChange: () => { },
    onBlur: () => { },
    maxLength: null,
    disabled: false,
};
InputMask.propTypes = {
    onClick: prop_types_1.default.func,
    className: prop_types_1.default.string,
    placeholder: prop_types_1.default.string,
    size: prop_types_1.default.oneOf(["large", "small"]),
    onChange: prop_types_1.default.func,
    onBlur: prop_types_1.default.func,
    maxLength: prop_types_1.default.number,
    value: prop_types_1.default.string,
    disabled: prop_types_1.default.bool,
    name: prop_types_1.default.string,
};
exports.default = InputMask;
//# sourceMappingURL=index.js.map